
const styles = {
  success: 'bg-green-500',
  'success-glowing': 'shadow-glowing-success',
  red: 'bg-red-100',
  gray: 'bg-gray-700',
  secondary: 'bg-yellow-300 text-gray1-800',
  'secondary-glowing': 'shadow-glowing-secondary'
}

export default {
  name: 'AppLabel',
  props: {
    type: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: 'span'
    },
    glowing: Boolean,
    rounded: Boolean,
    ignoreYPadding: Boolean,
    ignoreXPadding: Boolean,
    ignoreFlex: Boolean,
    arrow: Boolean
  },
  computed: {
    classList () {
      const classList = []

      if (!this.ignoreFlex) {
        classList.push('flex items-center justify-center')
      }

      if (!this.ignoreYPadding) {
        classList.push('py-0.5')
      }

      if (!this.ignoreXPadding) {
        classList.push('px-2.5')
      }

      if (styles[this.type]) {
        classList.push(styles[this.type])
      }

      if (this.glowing && styles[this.type + '-glowing']) {
        classList.push(styles[this.type + '-glowing'])
      }

      if (this.rounded) {
        classList.push('rounded-md')
      }

      if (this.arrow) {
        classList.push('label-arrow')
      }

      return classList
    }
  }
}
